import React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import {
  MusicNote as SessionIcon,
  Videocam as QuickTapIcon,
  EmojiEvents as ChallengeIcon,
  Collections as SeriesIcon,
  Category as CategoryIcon,
  SubdirectoryArrowRight as SubcategoryIcon,
} from "@mui/icons-material";
import StatCard from "./StatCard";
import SessionHelper from "../Helper/SessionHelper";
import RouteConfig from "../../constants/RouteConfig";

const ContentStats = ({ stats, loading }) => {
  // Helper function to check if user has permission for a route
  const hasPermissionForRoute = path => {
    const route = RouteConfig.find(r => r.path === path);
    if (!route || !route.requiredPermissions || route.requiredPermissions.length === 0) {
      return true; // If no permissions required, allow access
    }
    return SessionHelper.hasPermission(route.requiredPermissions);
  };

  const contentItems = [
    {
      title: "Sessions",
      value: typeof stats?.sessions === 'object' ? stats.sessions.total : stats?.sessions,
      breakdown: typeof stats?.sessions === 'object' ? { free: stats.sessions.free, premium: stats.sessions.premium } : null,
      icon: <SessionIcon />,
      link: "/sessions",
      tooltip: "Active sessions. Excludes audiobook chapters/sessions, challenge sessions, and series sessions."
    },
    {
      title: "Quick Taps",
      value: typeof stats?.quick_taps === 'object' ? stats.quick_taps.total : stats?.quick_taps,
      breakdown: typeof stats?.quick_taps === 'object' ? { free: stats.quick_taps.free, premium: stats.quick_taps.premium } : null,
      icon: <QuickTapIcon />,
      link: "/quick-taps",
      tooltip: "Active, non-deleted quick tap sessions available in the app."
    },
    {
      title: "Challenges",
      value: typeof stats?.challenges === 'object' ? stats.challenges.total : stats?.challenges,
      breakdown: typeof stats?.challenges === 'object' ? { free: stats.challenges.free, premium: stats.challenges.premium } : null,
      icon: <ChallengeIcon />,
      link: "/challenges",
      tooltip: "Active, non-deleted challenges available in the app."
    },
    { title: "Series", value: stats?.series, icon: <SeriesIcon />, link: "/series" },
    { title: "Categories", value: stats?.categories, icon: <CategoryIcon />, link: "/category" },
    { title: "Subcategories", value: stats?.subcategories, icon: <SubcategoryIcon />, link: "/subcategories" },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        },
        gap: 2,
      }}
    >
      {contentItems.map((item, index) => {
        const hasPermission = hasPermissionForRoute(item.link);

        // If user has permission, wrap in Link; otherwise, render StatCard directly
        if (hasPermission) {
          return (
            <Link key={index} to={item.link} style={{ textDecoration: "none", color: "inherit" }}>
              <StatCard
                title={item.title}
                value={item.value}
                breakdown={item.breakdown}
                icon={item.icon}
                loading={loading}
                tooltip={item.tooltip}
              />
            </Link>
          );
        }

        return (
          <Box key={index}>
            <StatCard
              title={item.title}
              value={item.value}
              breakdown={item.breakdown}
              icon={item.icon}
              loading={loading}
              tooltip={item.tooltip}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ContentStats;
